import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { SetupChecklist } from '@/features/platform/types'

export const setupQuery = () =>
  queryOptions({ queryKey: ['school', 'setup'], queryFn: () => api.get<SetupChecklist>('/school/setup') })

export function useSetupVisibility() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (dismiss: boolean) =>
      api.post<SetupChecklist>(dismiss ? '/school/setup/dismiss' : '/school/setup/reopen'),
    onSuccess: (data) => qc.setQueryData(setupQuery().queryKey, data),
  })
}
